import { createFrontendModule } from '@backstage/frontend-plugin-api';
import techdocsPlugin from '@backstage/plugin-techdocs/alpha';

// Show every team's docs on the TechDocs index, not only docs the user owns.
// Set in code so deployed environments get it without manifest config; this
// replaces any `initialFilter` set for `page:techdocs` in app-config.
const techdocsPage = techdocsPlugin.getExtension('page:techdocs').override({
  factory(originalFactory, { config }) {
    return originalFactory({ config: { ...config, initialFilter: 'all' } });
  },
});

export const techdocsModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [techdocsPage],
});
